import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_FileUploadField = _resolveComponent("FileUploadField")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      loading: _ctx.downloading,
      class: _normalizeClass(_ctx.showResumeRequired ? 'error-border' : '')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Upload Your Resume "),
            _createElementVNode("small", { class: "ml-2 error--text" }, "*", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "pt-0 pb-0" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("p", { class: "mb-0" }, "PDF file", -1),
                _createElementVNode("p", { class: "mb-0" }, "Maximum file size: 5 MB", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_v_col, {
              md: "12",
              sm: "12",
              cols: "12",
              class: "pt-0 pb-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FileUploadField, {
                  readonly: _ctx.isHiringmanager,
                  modelValue: _ctx.currentFile,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentFile) = $event)),
                  onChange: _ctx.fileChanged,
                  class: "mr-3",
                  accept: ".pdf",
                  dense: "",
                  "small-chips": "",
                  "show-size": _ctx.showSize,
                  outlined: "",
                  label: "Please upload your resume"
                }, null, 8, ["readonly", "modelValue", "onChange", "show-size"])
              ]),
              _: 1
            }),
            (_ctx.resumeMessage && _ctx.resumeMessage.length > 0)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  class: "mt-0 pt-0"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resumeMessage, (message) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: message,
                        class: "mb-0 error--text"
                      }, _toDisplayString(message), 1))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.personalDetailModel.CV)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  class: "pt-0"
                }, {
                  default: _withCtx(() => [
                    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "success-text" }, "You already have uploaded a resume. you can download it or you can upload a new one", -1)),
                    _createVNode(_component_v_col, { class: "pt-0 text-center" }, {
                      default: _withCtx(() => [
                        (!_ctx.isHiringmanager)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              class: "secondary pt-0",
                              fab: "",
                              title: "Download",
                              loading: _ctx.downloading,
                              onClick: _ctx.downloadCV
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                                    _createTextVNode("mdi-download")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["loading", "onClick"]))
                          : _createCommentVNode("", true),
                        (!_ctx.isHiringmanager)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              fab: "",
                              class: "error ml-5",
                              title: "Delete",
                              loading: _ctx.downloading,
                              onClick: _ctx.removeCV
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                                    _createTextVNode("mdi-delete")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["loading", "onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["loading", "class"])
  ]))
}